import { Stack, Typography } from "@mui/material"
import { formatPrice } from "@pharmupp/p3-front-commons"
import {
  LoyaltyProgramCard,
  type LoyaltyProgramCardProps,
} from "../../../LoyaltyProgram"

type KPICardProps = Omit<LoyaltyProgramCardProps, "value"> & {
  value?: number | null
}

const AverageBasketCard = ({ value, slotProps, ...props }: KPICardProps) => {
  return (
    <LoyaltyProgramCard
      {...props}
      value={
        <AverageBasketValue
          value={formatPrice(value, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
          })}
        />
      }
      slotProps={{
        Title: { variant: "16px" },
        Subtitle: slotProps?.Subtitle,
      }}
    />
  )
}

const AverageBasketValue = ({ value }: { value?: string }) => {
  return (
    <Stack component="span" direction="row" gap={1} alignItems="center">
      <Typography component="span" fontSize="inherit" fontWeight="inherit">
        {value || "-"}
      </Typography>
      {value && (
        <Typography variant="14px" fontWeight={500}>
          TTC
        </Typography>
      )}
    </Stack>
  )
}

export const AverageBasketCardWithCheques = (
  props: Omit<KPICardProps, "slotProps">,
) => {
  return (
    <AverageBasketCard
      {...props}
      slotProps={{
        Subtitle: {
          sx: (theme) => ({ color: theme.palette.tertiary.main }),
        },
      }}
    />
  )
}
export const AverageBasketCardWithoutCheques = (
  props: Omit<KPICardProps, "slotProps">,
) => {
  return <AverageBasketCard {...props} />
}
